import { Select } from '@mui/material';
import { styled } from '../../utils/styled';

export const StyledSelect = styled(Select)`
  box-shadow: none;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;

  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }

  .MuiSelect-icon {
    color: ${({ theme }) => theme.palette.primary.main};
    right: 0;
    top: calc(50% - 0.7em);
  }
`;
